/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import Reveal from "./Reveal";
import { LANDING } from "@/constants/testIds";
import { fetchGreenGiftProjects } from "@/lib/api";

const resolveAsset = (u) =>
  !u ? "" : u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`;

function PinIcon() {
  return (
    <svg className="project-region-icon" viewBox="0 0 12 12" fill="none" aria-hidden>
      <path
        d="M6 1a4 4 0 00-4 4c0 3 4 6 4 6s4-3 4-6a4 4 0 00-4-4zm0 5.5A1.5 1.5 0 116 3.5a1.5 1.5 0 010 3z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function Projects() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    fetchGreenGiftProjects()
      .then((list) => { if (alive && Array.isArray(list)) setItems(list); })
      .catch(() => { /* silent — section hides when empty */ });
    return () => { alive = false; };
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="projects">
      <div className="projects-header">
        <Reveal className="eyebrow">Our Active Projects</Reveal>
        <Reveal as="h2" delay={1} className="section-headline">
          Each project.
          <br />
          <em>A real impact.</em>
        </Reveal>
        <Reveal as="p" delay={2} className="section-sub">
          We are part of multiple active reforestation projects across India. Each one supports local communities while restoring India's natural ecosystems.
        </Reveal>
      </div>

      {items.map((p, i) => {
        const reverse = i % 2 === 1;
        const number = String(i + 1).padStart(2, "0");
        return (
          <div
            key={p.id}
            className={`project-banner ${reverse ? "reverse" : ""}`.trim()}
            data-testid={LANDING.projectCard(i + 1)}
          >
            <div className="project-content">
              <div className="project-index">Project {number}</div>
              <h3 className="project-name">{p.name}</h3>
              {p.location && (
                <div className="project-region">
                  <PinIcon />
                  {p.location}
                </div>
              )}
              {p.description && <p className="project-desc">{p.description}</p>}
              <div className="project-contact-note" data-testid={`project-contact-note-${i + 1}`}>
                Contact us to learn more about this project.
              </div>
            </div>
            <div className="project-image">
              {p.image ? (
                <img
                  src={resolveAsset(p.image)}
                  alt={p.name}
                  className="img project-image-img"
                  loading="lazy"
                />
              ) : (
                <div className="img project-image-placeholder" aria-hidden />
              )}
            </div>
          </div>
        );
      })}
    </section>
  );
}
